import { useContext } from "react";
import { DateTimeFormatContext } from "src/app/components/DateTimeFormatContext";

export const useDateTimeFormatContext = () => {
  return useContext(DateTimeFormatContext);
};
